export enum BookingSteps {
  start,
  packages,
  timeslots,
  hangouts,
  attendees,
  review,
  addons
}
